(ns client-portal.client.voice-insights.items.views
  (:require [client-portal.client.layout :as l]
            [client-portal.client.voice-insights.empty-state :as empty-state]
            [client-portal.client.voice-insights.items.data]
            [client-portal.client.voice-insights.items.charts.views :as items.charts]
            [client-portal.client.voice-insights.items.comparison.views :as items.comparison]
            [client-portal.client.voice-insights.shared :as vi.shared]
            [shared.core.amelia-light.components.components :as alc]
            [shared.core.components.components :as c]
            [shared.core.reactive :as re]
            [shared.core.style :as style]
            [shared.core.util :as util]))

(defn header-toolbar []
  (let [comparison-items- (re/subscribe [:vi-items/all-comparison-items-])
        view-mode- (re/subscribe [:vi-items/view-mode-])]
    [:div {:style {:display :flex
                   :align-items :flex-end
                   :justify-content :space-between
                   :margin-top 6}}
     [:div {:style {:display :flex
                    :flex-direction :column}}
      [alc/up-toggle-group
       {:type "single"
        :value @view-mode-
        :on-value-change (fn [v]
                           (when (seq v)
                             (re/dispatch [:vi-items/select-view-mode v])))
        :items (mapv (fn [{:keys [mode icon-type label]}]
                       {:value mode
                        :content [:div {:style {:display :flex
                                                :align-items :center
                                                :gap 6}}
                                  [c/material-icon {:icon-type icon-type
                                                    :style {:font-size 16}}]
                                  [:span label]]})
                     [{:mode "charts" :icon-type :timeline :label "Charts"}
                      {:mode "comparison"
                       :icon-type :compare
                       :label (str "Comparison"
                                   (when (not-empty @comparison-items-)
                                     (str " (" (count @comparison-items-) ")")))}])}]]]))

(defn header-container []
  (let [view-mode- (re/subscribe [:vi-items/view-mode-])]
    [:div {:id "item-analytics-header"
           :style (cond-> {:background-color (style/alc-color "Background/card_hex")
                           :padding "12px 16px 16px"
                           :top 0
                           :left 0
                           :z-index (inc (style/z :medium))}
                          (not= @view-mode- "charts")
                          (assoc :position :sticky))}
     [l/page-header {}
      "Item Analytics"]
     [header-toolbar]]))


(defn root [_]
  (let [view-mode- (re/subscribe [:vi-items/view-mode-])
        charts-data- (re/subscribe [:vi-items/charts-data-])
        items-list- (re/subscribe [:vi-items/list-by-current-concept-id-])]
    (re/create-class
      {:component-did-mount #(re/dispatch [:vi-items/initialize])
       :reagent-render
       (fn [args]
         @charts-data-
         (let [view-mode @view-mode-]
           [l/logged-in-with-header-nav-vi
            args
            [:div {:style {:display :flex
                           :flex-direction :column
                           :width "100%"
                           :min-height "100%"}}
             [header-container]
             [:div {:style {:flex 1
                            :display :flex
                            :flex-direction :column
                            :padding "0 16px 16px"}}
              (cond
                (and (= view-mode "charts") (util/loading? @charts-data-)) [empty-state/loading-charts-card]
                (and (= view-mode "comparison") (util/loading? @items-list-)) [empty-state/loading-comparisons-card]
                :else (case view-mode
                        "comparison" [items.comparison/comparison-view]
                        [items.charts/charts-view]))]]]))})))
